import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbDropdownModule, NgbDatepickerModule, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { ComboService } from '../../../Model/Combo/combo.service';
import { LoaderComponent } from '../../Loader/loader/loader.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { UtilityService } from '../../../Model/utility/utility.service';
import { CommonService } from '../../../Model/Common/common.service';
import { ReportsService } from '../../../Model/Reports/reports.service';
import pako from 'pako';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';

@Component({
  selector: 'app-site-date-wise-manpower-front',
  standalone: true,
  imports: [CommonModule, FormsModule, NgSelectModule, NgbDropdownModule, LoaderComponent, NgbDatepickerModule],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
  templateUrl: './site-date-wise-manpower-front.component.html',
  styleUrl: './site-date-wise-manpower-front.component.scss'
})
export class SiteDateWiseManpowerFrontComponent {
  isDisabled: boolean = false;
  Regions = [] as any;
  Zones = [] as any;
  Branchs = [] as any;
  Clients = [] as any;
  Sites = [] as any;
  LogData: any[] = []

  MinDate = {
    day: 1,
    month: 1,
    year: 1800
  };

  MaxDate = null as any;

  Filter = {
    SelectType: 'S',
    FromDate: null as any,
    FromDateObj: null as any,
    ToDate: null as any,
    ToDateObj: null as any,
    RegionId: null,
    ZoneId: null,
    BranchId: null,
    ClientId: null,
    SiteId: null,
  }

  constructor(
    private combo: ComboService,
    private utility: UtilityService,
    private dateFormat: CustomDateParserFormatter,
    protected common: CommonService,
    private report: ReportsService,
    private toast: ToastService,
    private download: DownloadSampleService,
  ) {
    this.common.getPageRights();
  }

  ngOnInit(): void {
    this.SelectDate('RegistrationDate');
    this.ComboLoad('Region');
    this.ComboLoad('Zone');
    this.ComboLoad('Branch');
  }

  Validate(form: any) {
    if (form.valid) {
      this.ESS_SiteDateWiseManpowerReport();
    }
    else {
      form.submitted = true;
    }
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    if (Combotype == 'Region') {
      this.Regions = [];
    } else if (Combotype == 'Zone') {
      this.Zones = [];
    } else if (Combotype == 'Branch') {
      this.Branchs = [];
      this.Clients = [];
      this.Sites = [];

      this.Filter.BranchId = null;
      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
    } else if (Combotype == 'Client') {
      this.Clients = [];
      this.Sites = [];

      this.Filter.ClientId = null;
      this.Filter.SiteId = null;
    } else if (Combotype == 'Site') {
      this.Sites = [];

      this.Filter.SiteId = null;
    }

    this.combo.ComboLoad({
      'Combotype': Combotype,
      'BranchId': (Combotype == 'Client' || Combotype == 'Site') ? this.Filter.BranchId : 0,
      'ClientId': (Combotype == 'Site') ? this.Filter.ClientId : 0,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'Region') {
          if (response.ComboLoad) {
            this.Regions = response.ComboLoad;
          }
        } else if (Combotype == 'Zone') {
          if (response.ComboLoad) {
            this.Zones = response.ComboLoad;
          }
        } else if (Combotype == 'Branch') {
          if (response.ComboLoad) {
            this.Branchs = response.ComboLoad;
          }
        } else if (Combotype == 'Client') {
          if (response.ComboLoad) {
            this.Clients = response.ComboLoad;
          }
        } else if (Combotype == 'Site') {
          if (response.ComboLoad) {
            this.Sites = response.ComboLoad;
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  SelectDate(SelectType: string) {
    this.isDisabled = true;
    this.utility.SelectDate({ 'SelectType': SelectType }).subscribe({
      next: (response) => {
        if (SelectType == 'RegistrationDate') {
          this.Filter.FromDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);
          this.Filter.FromDateObj.day = 1;
          this.Filter.ToDateObj = this.dateFormat.parse(response.Table[0].RegistrationDate);

          this.DateChange(null);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  DateChange(event: any) {
    this.MaxDate = this.Filter.FromDateObj ? { ...this.Filter.FromDateObj } : null;
    if (this.MaxDate != null && this.MaxDate != "") {
      this.MaxDate = this.common.addDaysToNgbDate(this.MaxDate, 30);

      if (event != null) {
        this.Filter.ToDateObj = this.common.addDaysToNgbDate(this.Filter.FromDateObj, 30);
      }
    }
  }



  ESS_SiteDateWiseManpowerReport() {
    this.isDisabled = true;
    if (this.Filter.FromDateObj != null && this.Filter.FromDateObj != "") {
      this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    }

    if (this.Filter.ToDateObj != null && this.Filter.ToDateObj != "") {
      this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    }

    this.report.ESS_SiteDateWiseManpowerReport(this.Filter).subscribe({
      next: (response) => {
        if (response.Table && response.Table.length > 0) {
          this.download.exportInChunks(response.Table, "SiteDateWiseManpower");
          this.isDisabled = false;
        }
        else {
          this.isDisabled = false;
          this.toast.show({ message: 'Data not found!', type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }
}
